import { useBrokerIntegration } from '../contexts/BrokerIntegrationContextCompat';

export const useActiveBroker = () => {
  const { activeConnections } = useBrokerIntegration();
  
  // Get the first active broker
  const activeBroker = activeConnections?.[0];
  
  return {
    activeBroker,
    brokerName: activeBroker?.broker || 'Unknown',
    hasActiveBroker: !!activeBroker,
    brokerType: activeBroker?.broker || null
  };
};
